import { menuAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { regular } from './Text';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(menuAnatomy.keys);

const plainSmall = definePartsStyle({
  list: {
    bg: 'white',
    py: 0,
    borderRadius: 'md',
  },
  item: {
    ...regular,
    _focus: {
      bg: 'yPrimary.100',
      color: 'yPrimary.600',
    },
    _hover: {
      bg: 'yGray.100',
      color: 'yGray.950',
    },
    _first: {
      borderTopRadius: 'md',
    },
    _last: {
      borderBottomRadius: 'md',
    },
  },
});
const actions = definePartsStyle({
  list: {
    bg: 'white',
    py: 0,
    borderRadius: 'md',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  },
  item: {
    ...regular,
    p: 3,
    _focus: {
      bg: 'transparent',
    },
    _hover: {
      bg: 'yGray.50',
    },
    _first: {
      borderTopRadius: 'md',
    },
    _last: {
      borderBottomRadius: 'md',
    },
  },
});

const menuTheme = defineMultiStyleConfig({
  variants: {
    plainSmall,
    actions,
  },
});
export default menuTheme;
